module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleA-img2.2dcff8c6.png";